module.exports = "/_next/static/images/f8045780e2521ecb375e27f26931fb0a-paperwork@tablet768.jpg";